import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper/index';
import './styles.css';
import Slider from "../../components/slider";
import BodyControl from "../../components/body";
import {Cta} from "../../blocks";
import {convertPipeToBrTag} from "../../utils";
import customCarImage from "./image-custom.png";
// import iconConsultation from "./icon-consultation.png";
import {IS_MOBILE} from "../../constants/environment";
import {Map} from '../../components'
import {convertKataToRome} from "../../utils";
import MakerIcon from "./icon-maker.png";

/**
 *  DealerDetailContent
 */
class DealerDetailContent extends Component {

  static iconBlank = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAgMAAABj6rKSAAAADFBMVEUAAAD19fX19fX19fULZa1RAAAAA3RSTlMAiHfHTTICAAAATklEQVQoz2OgM2ANBYEAMJv/Pwh8wGRfBSoJh7IPAAlmdDZXA5QNFqU5+9WqVatWQ9gQd2KyEf4C6oQAItlA00EAKRT+Y7Ahpocy0B4AANNmVtHLQfM4AAAAAElFTkSuQmCC';
  static iconTestDrive = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAmVBMVEUAAAAZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkYGBgZGRkYGBgZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRkZGRlb5GNTAAAAMnRSTlMAZu+R+wbi9ogjz8uTNaNMKwPq5t3An5ltae3Z1cS0VC8UDquod1nzuIl+Px0ar6dnX3E0cQYAAAGWSURBVDjL5dDXkptAEIXhJg1B5IxAAWVL2nTe/+Hcg1yUF0YON3thf1UaKPovpBb9N+IOSp47b10dOLfFvnKOtcbqo1PtV60NpLPa8mCeEppJPkwsps9rQKNkezs1R8dxDJ+PY32KtsljMurfw9VCx4qoxMyaEg/6oig/diTpGNwoADuLPF+wPBdnsIgiDJZBwDGwKEtzTbTiXaxPi7zkaC0qzLL0gKKQscNHF8g31DSxARq6dXxnIMtkHPKxpaSD3WgT7zqyHQ+J3uB5MjariC8RntDkN1QmfJ9vUt6ZV3VzKGX83t2Fr/c7yb1sbn/tBShIkn/mb3VAHA9xQ4fKfR661YF8PH4z4JIJM4zVaRzykE6AEEPMH2a+Br12NcKLJ2xbeJfQuGp98GoCSOkO9iM+YGBj4vFAbIjGWK4bXdcZFESo8Tqf48EeM3tiyrhPMZH2T2PaYGJDz2MKfIGR8ANSx6O4ObS23b41MTFFrPbF8R/5upiU1PFSHS/H+fKn+Js6Nsa5DAwdTDcsdWyNc+vv4n/ed1RHfTj44/2vAAAAAElFTkSuQmCC';
  static iconTestDriveHover = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAnFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////+TINBkAAAAM3RSTlMAZu2RBfviy/aIIzXPn0wr6t3Ao5ltaQLm2cS0k1Qv8tWrqIl3WRQPuH4/HRrvr6dnXwsc6YM2AAABmElEQVQ4y+XP6W6jMBSG4cNis0PYIZC12ZOu3/3f2xzoKJmCo07/9Ef7Shjk88jI9GuKfCjz3bF1H4FFnawyZ5NrXL5xstW0toHJSJs+xLakUeWrgDXczwGNyvlpW2wcxzEMXjb5NpyX75Nr+5d0ai0wJQowqqHSh24lweu+x4/oO5EHbiHj2OLiWC7AhRSiT/c8xoAVBKIhmvJdzA8XucSoTUpEEPhAknTY4WXpdSfkNGgGFHRa8tcDqqrDAS9zMpewC23Qi47qjYdEz/D9Doss5FeIO2ndHzIBw+CPCdC8Ebmx2lZ87v4AyPOZunvZe/qkC5BQF9DQpy2BKOpxQevMvQ/dbE0t0LY9dklApJGaRikPaQtI2WN+OPHk7bSjkR4sadvSOqTGUdt5TwLAhM7g/uI1+mwMet+QM1Y3TJfw2FRQJFONr/MR963GdkWcEu8mQzvZ3cU0G+IZ3cfktfImZeuREt+KinVt2/VzERGnwOq+Gf9X34dJmRrraqxf5/o/+EGNjeu8A4YOTjdMNTavc/Nr+Mf3B9f8fuEURnlBAAAAAElFTkSuQmCC';
  static iconMap = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAApVBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVjjqjoAAAANnRSTlMA8ZZaAof9w+d2Iwv1RS4or6JiNe/rzaqNUB8H+N7a0ce5tHFuZ14P8teKFr6cgnxXTD0aEmy25xbaAAABnElEQVQ4y+3U2XKCMBSA4QNGFBBkERFxF9S6b837P1o5hCNYHcx1p/+NjHxkSMgEahpup0ow09cgkd7heUH02Q44pTU+2YiXdbr1lk1wyGPXd1GH9dhHo+JTs+xiZNbiJWIrnyddYRZ7h5tIVo+J0hT5JHmzkickfRNg2MariDDnG/VluiuOfTUHueU2YUybR6yU3TMYvFrACBeN9TtkGZ6bDTaEfhWrYBJWLEfL1/7guWNx9wSritVsCGeNWGDcM0Hl5mbhAasM7YKRjdYmDGB6U/Fp57qfv+FVI9u7QTrKfksslr91jatLLToDwK7zCzdwJmVxn14CU+oxGL18rU0pDJFG21MCwwD3hyyOZweQxnAz5fEO4C6Nw51/lMat/bgpjzn/x38Na1vjDWa+Ph9xPr2wJ5xxx2JVzOzlQuFFk+X6gfWxOAO/TcQIE6dHsC2OKtUuMLDLPP9Lyd7QScP2A7qeAcZAPLgfZVjUVTeFIBimdAqb6ZSLgFonE4I9J7EZVCsOTihj1kLjymJJ8KlhMyBMGT7B12KvDz/Dw3X9+GrjcAAAAABJRU5ErkJggg==';
  static iconTel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAqFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fUjfWL/AAAAN3RSTlMA2vwaEgr18ZJoXPmHcE40H+vTz652SEEj3svBu6CBLgYC9+3ox7eppJxiVD0pDwPlzrCPe5qV2I+PWQAAAZVJREFUOMvdlNl2gjAQhgFlEZRFVOraqlXrUrv3e/83a0hqPVVMvPa/mSHnO5PJ8CfWrek+jwbd2nXsQx+hWbC/Bg5ReiyugHMYBT7ghEa2ByTW/sMRdM8EL2FYxkIUf3UNowBime0caOjhMdhTla5hqWVr0bFcCG0t3ITs0GgDFlq4Dc1DHsDKBPfTY97VwhvAVr54lgPXavJHN0WiRRXDk4juHCYmuAXsVIxMPr3zoCPiPoOxgXVz8FPVjXOnZ186QFhaJIJvA7tGbf4ygKxehdQ/3+yW7GEFLNzfkYRVJwo8hALLSgci5mW9GOico8nKQelj4wODkr0XWf+sid5Icl5go9Rxy70ysZSc9qrQx8+6VZP0TDo5tasaXiNkN8pikh4+S//0qbpOC2hvp4cr8h7LWMyp9MQY3k/Xug7VLo7BSf+tpCPE2qbyUXuVZjx+t/zyvLvLbowPH9OtnMjwki0fbPAKNcaGRL3W1LqkZAZO0Iu7y0j9E60ptxFHDQvTmzlHyXtKLKPqkzc/y79C17op/QBoj0D2+QpEYwAAAABJRU5ErkJggg==';

  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      isMounted: false,
      currentShopIntroductionImageIndex: 0,
      today: null,
      currentTestDriveBodyType: null,
      isOpenedQRModal: false,
      informationHeight: null,
    };
    //
    this.today = null;
    this.calendersInfo = null;
    this.serviceType = this.getIsShopServiceType();
    this.informationRefs = [];
    this.testDriveBodyTypeNum = 5;
    this.bodyTypesInfo = this.getBodyTypesInfo();
    this.offers = null;
    //
    //console.log(this.props);
  }

  componentDidMount() {
    this.today = new Date();
    this.offers = this.getOffers();
    //
    if (window.matchMedia('(min-width:768px)').matches) {
      this.testDriveBodyTypeNum = 5;
    } else {
      this.testDriveBodyTypeNum = 2;
    }
    //
    let currentTestDriveBodyType = null;

    if (this.getArray(this.props.shop.cars)) {
      let savedBodyType = this.getSavedBodyType();
      if (savedBodyType !== null) {
        if (this.bodyTypesInfo.length <= this.testDriveBodyTypeNum) {
          currentTestDriveBodyType = savedBodyType;
        }
      } else {
        if (this.bodyTypesInfo.length <= this.testDriveBodyTypeNum) {
          currentTestDriveBodyType = this.bodyTypesInfo[0].bodyType;
        }
      }
    }

    //
    this.setState({
      isMounted: true,
      today: this.today,
      currentTestDriveBodyType: currentTestDriveBodyType,
    });
    //
    this.calendersInfo = this.getCalendersInfo(this.today);

    //console.log('販売会社のサービスタイプ');
    //console.log(this.serviceType);
    //console.log('本日の日付 : ' + this.today);
    //console.log(this.calendersInfo);

    // Cookie設定
    this.setCookie('mj_drl', this.props.shop.dealerId);
    this.setCookie('mj_shp', this.props.shop.shopId);
    //
    window.addEventListener('resize', this.handleResize);
    setTimeout(()=> {
      this.handleResize();
    }, 200)
  };

  componentWillUnmount() {
    this.setState({
      isMounted: false,
    });
    window.removeEventListener('resize', this.handleResize);
  }

  render() {

    console.log('DealerDetailContent : render');

    // ヘッダー表示
    const renderHeader = ()=> {
      const prefecture = this.getText(this.props.shop.address.prefecture);
      const address1 = this.getText(this.props.shop.address.address1);
      const address2 = this.getText(this.props.shop.address.address2);
      return (
        <div className="DealerDetailContent__header">
          <div className="DealerDetailContent__header__box">
            <div className="DealerDetailContent__header__box-left">
              <h4 className="DealerDetailContent__header__heading">
                <span>{this.getText(this.props.shop.dealerName)}</span>
                {this.getText(this.props.shop.shopName)}
              </h4>
            </div>
            <div className="DealerDetailContent__header__box-right">
              <dl className="DealerDetailContent__header__list-dl">
                <dt>住所</dt>
                <dd>{'〒 ' + this.getText(this.props.shop.address.zip) + ' ' + ((prefecture) ? prefecture : '') + ((address1) ? address1 : '') + ((address2) ? address2 : '')}</dd>
              </dl>
              <dl className="DealerDetailContent__header__list-dl">
                <dt>TEL</dt>
                <dd>{this.getText(this.props.shop.contact.phoneNumber)}</dd>
              </dl>
            </div>
          </div>
          <ul className="DealerDetailContent__header__list-ul">
            <li>
              <Cta
                {...{
                  ctaType: 'Free',
                  href: 'javascript:void(0);',
                  text: 'MAP',
                  targetBlank: false,
                  color: 'Dark',
                  buttonStyle: 'Action',
                  linkType: 'Button-With-Icon',
                  iconSrc: DealerDetailContent.iconMap,
                  handleClick: (e)=> {
                    e.preventDefault();
                    //
                    BodyControl.scrollToNode(this.refs.map);
                  }
                }}
            />
            </li>
            <li>
              <Cta
                {...{
                  ctaType: 'Free',
                  href: 'tel:' + this.getText(this.props.shop.contact.phoneNumber).replace(/-/g, ''),
                  text: 'TEL',
                  targetBlank: false,
                  color: 'Dark',
                  buttonStyle: 'Action',
                  linkType: 'Button-With-Icon',
                  iconSrc: DealerDetailContent.iconTel,
                }}
              />
            </li>
          </ul>
        </div>
      )
    };

    // SHOP INTRODUCTION表示
    const renderShopIntroduction = ()=> {

      const renderImages = ()=> {

        const renderDescription = ()=> {
          const description = this.getText(this.props.shop.dealerInfo.description);
          if (description) {
            return (
              <p className="DealerDetailContent__shop-introduction__description Wysiwyg" dangerouslySetInnerHTML={{__html: description}}/>
            )
          } else {
            return null;
          }
        };

        const renderSmallImages = ()=> {
          const images = this.getArray(this.props.shop.dealerInfo.images);
          if (images !== null) {
            const arr = [(images[0]) ? images[0] : null, (images[1]) ? images[1] : null, (images[2]) ? images[2] : null];
            return (
              <ul className="DealerDetailContent__shop-introduction__small-images">
                {arr.map((image, index)=> {
                  if (arr[index]) {
                    return (
                      <li key={index}>
                        <span>
                          <img src={this.getText(arr[index].image)}/>
                        </span>
                      </li>
                    )
                  } else {
                    return (
                      <li key={index} />
                    )
                  }
                })}
              </ul>
            )
          } else {
            return null;
          }
        };

        const newImages = this.getArray(this.props.shop.dealerInfo.newImages);
        const defaultImage = this.getText(this.props.shop.dealerInfo.defaultImage);
        if (newImages !== null) {
          if (2 <= newImages.length) {
            return (
              <div>
                <div className="DealerDetailContent__shop-introduction__large-images">
                  <div className="DealerDetailContent__shop-introduction__large-images__box">
                    <Slider
                      ref="slider"
                      settings={{
                        autoplay: false,
                        speed: 1000,
                        ease: 'linear',
                        fade: true,
                        infinite: true,
                        initialSlide: this.state.currentShopIntroductionImageIndex,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        swipe: false,
                        draggable: false,
                        arrows: false,
                        dots: false,
                        adaptiveHeight: false,
                        centerMode: false,
                        centerPadding: 0,
                        focusOnSelect: true,
                        //lazyLoad: 'progressive',
                        lazyLoad: 'ondemand',
                        waitForAnimate: false,
                        beforeChange: (old, current) => {
                          if (this.refs.thumbnail) this.refs.thumbnail.slickGoTo(current);
                        },
                        responsive: [
                          {
                            breakpoint: 767,
                            settings: {
                              swipe: true,
                              arrows: false,
                              fade: false,
                              dots: true,
                              //prevArrow: '<div></div>',
                              //nextArrow: '<div></div>',
                            },
                          },
                        ],
                      }}
                    >
                      {newImages.map((newImage, index)=> {
                        if (5 <= index) return null;
                        return (
                          <div key={index} className="DealerDetailContent__shop-introduction__large-images__image">
                            <span style={{backgroundImage: 'url(' + this.getText(newImage.image) + ')'}}/>
                            {/*<img key={index} src={this.getText(newImage.image)}/>*/}
                          </div>
                        )
                      })}
                    </Slider>
                  </div>
                  <div className="DealerDetailContent__shop-introduction__large-images__box2">
                    <ul className="DealerDetailContent__shop-introduction__large-images__list-ul">
                      {newImages.map((newImage, index)=> {
                        if (5 <= index) return null;
                        return (
                          <li key={index}>
                            <a className={'DealerDetailContent__shop-introduction__large-images__link' + ((this.state.currentShopIntroductionImageIndex === index) ? ' current' : '')} href="javascript:void(0);" onClick={(e)=> {
                              e.preventDefault();
                              //
                              if (this.state.currentShopIntroductionImageIndex !== index) {
                                this.setState({
                                  currentShopIntroductionImageIndex: index
                                });
                                if (this.refs.slider) this.refs.slider.slickGoTo(index);
                              }
                            }}>
                              <span style={{backgroundImage: 'url(' + this.getText(newImage.image) + ')'}}/>
                              {/*<img src={this.getText(newImage.image)}/>*/}
                            </a>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                </div>
                {renderDescription()}
              </div>
            )
          } else {
            return (
              <div>
                <img className="DealerDetailContent__shop-introduction__large-image" src={this.getText(newImages[0].image)}/>
                {renderDescription()}
              </div>
            )
          }
        } else {
          if (defaultImage !== null) {
            return (
              <div>
                <img className="DealerDetailContent__shop-introduction__large-image" src={defaultImage}/>
                {renderDescription()}
                {renderSmallImages()}
              </div>
            )
          } else {
            return (
              <div>
                {renderDescription()}
              </div>
            );
          }
        }
      };

      return (
        <div className="DealerDetailContent__shop-introduction">
          <div className="DealerDetailContent__shop-introduction__heading Wysiwyg">
            <div className="DealerDetailContent__shop-introduction__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.shopIntroductionText)}}/>
            <div className="DealerDetailContent__shop-introduction__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.shopIntroductionText, this.props.mbShopIntroductionText)}}/>
          </div>
          {renderImages()}
        </div>
      )
    };

    // ONLINE SERVICE表示
    const renderOnlineService = ()=> {

      // 試乗車一覧
      const renderTestDrive = ()=> {
        //if (this.props.shop.cta.hasTestDrive === true) {
        if (this.getArray(this.props.shop.cars)) {
          const src = this.getText(this.props.testDriveImage);
          return (
            <li>
              <a className="DealerDetailContent__online-service__link" href="javascript:void(0);" onClick={(e)=> {
                e.preventDefault();
                //
                BodyControl.scrollToNode(this.refs.testdrive);
              }}>
                <span>
                  <span>
                    {(src) ? <img className="DealerDetailContent__online-service__icon" src={src} /> : null}
                    {this.getText(this.props.testDriveTitle, '試乗車一覧')}
                  </span>
                </span>
              </a>
            </li>
          )
        } else {
          return null;
        }
      };

      // 商談申込
      const renderConsultation = ()=> {
        if (this.props.shop.cta.brochures === true) {
          let url = 'https://my.mazda.co.jp/purchase/consultation/index.html';
          url += '?select_ken=' + encodeURIComponent(this.getText(this.props.shop.address.prefecture));
          url += '&dealer_code=' + this.getText(this.props.shop.dealerId);
          url += '&shop_code=' + this.getText(this.props.shop.shopId);
          let src = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            src = '/assets-dev/assets/purchase/dealer/detail/icon_meeting_dark.png';
          } else {
            src = '/globalassets/assets/purchase/dealer/detail/icon_meeting_dark.png';
          }
          return (
            <li>
              <a className="DealerDetailContent__online-service__link" href={url}>
                  <span>
                    <span>
                      <img className="DealerDetailContent__online-service__icon" src={src} />
                      {/*<img className="DealerDetailContent__online-service__icon" src={iconConsultation} />*/}
                      商談申込
                    </span>
                  </span>
              </a>
            </li>
          )
        } else {
          return null;
        }
      };

      // カタログ請求
      const renderCatalogue = ()=> {
        if (this.props.shop.cta.brochures === true) {
          const src = this.getText(this.props.catalogImage);
          //
          let url = 'https://my.mazda.co.jp/purchase/catalog/index.html';
          // let url = 'https://ssl.mazda.co.jp/purchase/catalog/';
          // if (this.state.isMounted === true) {
          //   if (IS_MOBILE) {
          //     url = 'https://ssl.mazda.co.jp/sp/purchase/catalog/';
          //   }
          // }
          //
          return (
            <li>
              <a className="DealerDetailContent__online-service__link" href={url + '?dlr=' + this.getText(this.props.shop.dealerId) + '&shp=' + this.getText(this.props.shop.shopId)}>
                <span>
                  <span>
                    {(src) ? <img className="DealerDetailContent__online-service__icon" src={src} /> : null}
                    {this.getText(this.props.catalogTitle, 'カタログ請求')}
                  </span>
                </span>
              </a>
            </li>
          )
        } else {
          return null;
        }
      };

      // 見積依頼
      const renderEstimate = ()=> {
        if (this.props.shop.cta.requestPriceEstimate === true) {
          const src = this.getText(this.props.estimateImage);
          //
          let url = '/purchase/estimate/';
          // let url = 'https://ssl.mazda.co.jp/purchase/estimate/';
          // if (this.state.isMounted === true) {
          //   if (IS_MOBILE) {
          //     url = 'https://ssl.mazda.co.jp/sp/purchase/estimate/';
          //   }
          // }
          //
          return (
            <li>
              <a className="DealerDetailContent__online-service__link" href={url + '?dlr=' + this.getText(this.props.shop.dealerId) + '&shp=' + this.getText(this.props.shop.shopId)}>
                <span>
                  <span>
                    {(src) ? <img className="DealerDetailContent__online-service__icon" src={src} /> : null}
                    {this.getText(this.props.estimateTitle, '見積依頼')}
                  </span>
                </span>
              </a>
            </li>
          )
        } else {
          return null;
        }
      };

      // 中古車検索
      const renderUsedCar = ()=> {
        if (this.props.shop.cta.secondhand === true) {
          const src = this.getText(this.props.uCarImage);
          return (
            <li>
              <a className="DealerDetailContent__online-service__link" href={'http://www2.mazda.co.jp/purchase/ucar/result.html' + '?dc=' + this.getText(this.props.shop.dealerId) + '&sc=' + this.getText(this.props.shop.shopId)}>
                <span>
                  <span>
                    {(src) ? <img className="DealerDetailContent__online-service__icon" src={src} /> : null}
                    {this.getText(this.props.uCarTitle, '中古車検索')}
                  </span>
                </span>
              </a>
            </li>
          )
        } else {
          return null;
        }
      };

      return (
        <div className="DealerDetailContent__online-service">
          <div className="DealerDetailContent__online-service__heading Wysiwyg">
            <div className="DealerDetailContent__online-service__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.onlineServiceText)}}/>
            <div className="DealerDetailContent__online-service__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.onlineServiceText, this.props.mbOnlineServiceText)}}/>
          </div>
          <ul className="DealerDetailContent__online-service__list-ul">
            {renderTestDrive()}
            {renderConsultation()}
            {renderCatalogue()}
            {renderEstimate()}
            {renderUsedCar()}
          </ul>
        </div>
      )
      // // if (this.props.shop.cta.requestPriceEstimate || this.props.shop.cta.brochures || this.props.shop.cta.secondhand || this.props.shop.cta.hasTestDrive) {
      // if (this.props.shop.cta.requestPriceEstimate || this.props.shop.cta.brochures || this.props.shop.cta.secondhand || this.getArray(this.props.shop.cars)) {
      //   return (
      //     <div className="DealerDetailContent__online-service">
      //       <div className="DealerDetailContent__online-service__heading Wysiwyg">
      //         <div className="DealerDetailContent__online-service__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.onlineServiceText)}}/>
      //         <div className="DealerDetailContent__online-service__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.onlineServiceText, this.props.mbOnlineServiceText)}}/>
      //       </div>
      //       <ul className="DealerDetailContent__online-service__list-ul">
      //         {renderTestDrive()}
      //         {renderConsultation()}
      //         {renderCatalogue()}
      //         {renderEstimate()}
      //         {renderUsedCar()}
      //       </ul>
      //     </div>
      //   )
      // } else {
      //   return null;
      // }
    };

    // SHOP SERVICE表示
    const renderShopService = ()=> {

      // 取扱サービス
      const renderMainService = ()=> {

        const getService = (label)=> {
          let i, max;
          for (i = 0, max = this.props.shop.services.length; i < max; i = i + 1) {
            const service = this.props.shop.services[i];
            if (service.service === label && service.isHighlighted === true) {
              return service.service;
            }
          }
          return null;
        };

        const newCar = getService('新車');
        const usedCar = getService('中古車');
        const repair = getService('サービス');

        return (
          <dl className="DealerDetailContent__shop-service__list-dl">
            <dt>取扱サービス</dt>
            <dd className={(newCar) ? 'active' : ''}>新車</dd>
            <dd className={(usedCar) ? 'active' : ''}>中古車</dd>
            <dd className={(repair) ? 'active' : ''}>サービス</dd>
          </dl>
        )
      };

      // 店舗設備
      const renderSubService = ()=> {

        const getService = ()=> {
          let arr = [];
          let i, max;
          for (i = 0, max = this.props.shop.services.length; i < max; i = i + 1) {
            const service = this.props.shop.services[i];
            if (service.service !== '新車' && service.service !== '中古車' && service.service !== 'サービス') {
              if (service.isHighlighted === true) {
                arr.push(service.service);
              }
            }
          }
          return arr;
        };

        const services = this.getArray(getService());
        if (services) {
          return (
            <dl className="DealerDetailContent__shop-service__list-dl">
              <dt>店舗設備</dt>
              {services.map((service, index)=> {
                return (
                  <dd className="active" key={index}>{service}</dd>
                )
              })}
            </dl>
          )
        }
      };

      return (
        <div className="DealerDetailContent__shop-service">
          <div className="DealerDetailContent__shop-service__heading Wysiwyg">
            <div className="DealerDetailContent__shop-service__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.shopServiceText)}}/>
            <div className="DealerDetailContent__shop-service__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.shopServiceText, this.props.mbShopServiceText)}}/>
          </div>
          <div className="DealerDetailContent__shop-service__box">
            <div className="DealerDetailContent__shop-service__box-left">
              {renderMainService()}
            </div>
            <div className="DealerDetailContent__shop-service__box-right">
              {renderSubService()}
            </div>
          </div>
        </div>
      )
    };

    // INFORMATION表示
    const renderInformation = ()=> {
      const information = this.getArray(this.props.shop.dealerInfo.information);
      let count = 0;
      this.informationRefs = [];
      if (information !== null) {
        return (
          <div className="DealerDetailContent__information">
            <div className="DealerDetailContent__information__heading Wysiwyg">
              <div className="DealerDetailContent__information__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.informationText)}}/>
              <div className="DealerDetailContent__information__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.informationText, this.props.mbInformationText)}}/>
            </div>
            <ul className="DealerDetailContent__information__list-ul">
              {information.map((info, index)=> {
                if (3 <= count) return;
                const title = this.getText(info.title);
                const description = this.getText(info.description);
                if (title !== null || description !== null) {
                  count = count + 1;
                  this.informationRefs.push('information' + index);
                  return (
                    <li key={index}>
                      <div className="DealerDetailContent__information__box" style={(1 <= this.state.informationHeight) ? {height: this.state.informationHeight} : {height: 'auto'}}>
                        <dl className="DealerDetailContent__information__list-dl" ref={'information' + index}>
                          <dt className="Wysiwyg" dangerouslySetInnerHTML={{__html: this.getText(info.title)}}/>
                          <dd className="Wysiwyg" dangerouslySetInnerHTML={{__html: this.getText(info.description)}}/>
                        </dl>
                      </div>
                    </li>
                  )
                } else {
                  return null;
                }
              })}
            </ul>
          </div>
        )
      } else {
        return null;
      }
    };

    // EVENT & CAMPAIGN表示
    const renderEventCampaign = ()=> {
      if (this.offers !== null) {
        return (
          <div className="DealerDetailContent__event-campaign">
            <div className="DealerDetailContent__event-campaign__heading Wysiwyg">
              <div className="DealerDetailContent__event-campaign__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.eventAndCampaignText)}}/>
              <div className="DealerDetailContent__event-campaign__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.eventAndCampaignText, this.props.mbEventAndCampaignText)}}/>
            </div>
            <ul className="DealerDetailContent__event-campaign__list-ul">
              {this.offers.map((offer, index)=> {
                if (index < 3) {
                  return (
                    <li key={index}>
                      <div className="DealerDetailContent__event-campaign__box">
                        {(offer.imageUrl !== null) ?
                          <div className="DealerDetailContent__event-campaign__box-left">
                            <img src={offer.imageUrl} />
                          </div>
                          : ''}
                        {(offer.title !== null || offer.description !== null) ?
                          <div className="DealerDetailContent__event-campaign__box-center">
                            <dl className="DealerDetailContent__event-campaign__list-dl">
                              <dt className="Wysiwyg" dangerouslySetInnerHTML={{__html: offer.title}}/>
                              <dd className="Wysiwyg" dangerouslySetInnerHTML={{__html: offer.description}}/>
                            </dl>
                          </div>
                          : ''}
                        {(offer.offerLink !== null) ?
                          <div className="DealerDetailContent__event-campaign__box-right">
                            <Cta
                              {...{
                                ctaType: 'Free',
                                href: offer.offerLink,
                                text: '詳細はこちら',
                                targetBlank: false,
                                color: 'Dark',
                                buttonStyle: 'Action',
                                linkType: 'Button',
                              }}
                            />
                          </div>
                          : ''}
                      </div>
                    </li>
                  )
                } else {
                  return null;
                }
              })}
            </ul>
          </div>
        )
      } else {
        return null;
      }
    };

    // TEST DRIVE表示
    const renderTestDrive = ()=> {

      const renderBodyTypes = ()=> {

        // ボディータイプ画像取得
        const getBodyTypeImageSrc = (modelName, carId, carTypeCode = null) => {
          let str = '';
          if (0 <= String(location.hostname).indexOf('localhost')) {
            str = '/assets-dev/assets/cars/';
          } else {
            str = '/globalassets/assets/cars/';
          }
          str = str + modelName + '/';
          str = str + carId + '/';
          if (carTypeCode !== null) {
            str = str + carTypeCode + '/';
            str = str + 'common/default_s.png';
            str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
            return str;
          } else {
            str = str + 'common/default_s.png';
            str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
            return str;
          }
        };

        // 機種情報取得
        //const getVariantsInfo = (modelName, carId, carTypeCode)=> {
        const getVariantsInfo = (modelName, carId)=> {
          if (!this.getText(modelName) || !this.getText(carId)) return null;
          //if (!this.getText(modelName) || !this.getText(carId) || !this.getText(carTypeCode)) return null;
          let i, max;
          for (i = 0, max = this.props.shop.cars.length; i < max; i = i + 1) {
            const car = this.props.shop.cars[i];
            if (car && modelName === car.modelName) {
              if (!car.bodyTypes) continue;
              let j, max2;
              for (j = 0, max2 = car.bodyTypes.length; j < max2; j = j + 1) {
                const bodyType = car.bodyTypes[j];
                if (bodyType && carId === bodyType.carId) {
                  if (!bodyType.generations) continue;
                  let k, max3;
                  let arr = [];
                  for (k = 0, max3 = bodyType.generations.length; k < max3; k = k + 1) {
                    const generation = bodyType.generations[k];
                    //if (generation && carTypeCode === generation.carTypeCode) {
                    if (generation) {
                      //let arr = [];
                      if (!generation.grades) continue;
                      let h, max4;
                      for (h = 0, max4 = generation.grades.length; h < max4; h = h + 1) {
                        const grade = generation.grades[h];
                        const gradeName = grade.grade;
                        const engine = grade.engine.name;
                        const fuel = grade.engine.fuel;
                        if (!grade.variants) continue;
                        let g, max5;
                        for (g = 0, max5 = grade.variants.length; g < max5; g = g + 1) {
                          const variant = grade.variants[g];
                          arr.push({
                            modelName: modelName,
                            carId: carId,
                            //carTypeCode: carTypeCode,
                            carTypeCode: generation.carTypeCode,
                            grade: gradeName,
                            engine: engine,
                            fuel: fuel,
                            variantId: variant.variantId,
                            drive: variant.drive,
                            transmission: variant.transmission,
                            settingExist: variant.settingExist,
                            customImage: variant.customImage,
                            trialCarId: variant.trialCarId,
                            description: variant.description,
                            memo: variant.memo,
                            trialCarColor: variant.trialCarColor,
                            trialCarColorCode: variant.trialCarColorCode,
                          })
                        }
                      }
                      // return arr;
                    }
                  }

                  return arr;
                }
              }
            }
          }
          return null;
        };

        let arr = [];
        let i, max;
        for (i = 0, max = Math.ceil(this.bodyTypesInfo.length / this.testDriveBodyTypeNum); i < max; i = i + 1) {
          arr.push(i * this.testDriveBodyTypeNum);
        }
        return (
          <div>
            {arr.map((start, index)=> {
              return (
                <div key={index}>
                  <div className="DealerDetailContent__text-drive__body-type">
                    <ul className="DealerDetailContent__text-drive__body-type__list">
                      {this.bodyTypesInfo.map((bodyType, index2)=> {
                        if (start <= index2 && index2 < start + this.testDriveBodyTypeNum) {
                          return (
                            <li key={index2} ref={bodyType.bodyType}>
                              <a className={'DealerDetailContent__text-drive__body-type__link' + ((this.state.currentTestDriveBodyType === bodyType.bodyType) ? ' current' : '')}
                                 href="javascript:void(0);"
                                 onClick={(e)=> {
                                  e.preventDefault();
                                  //
                                  if (this.state.currentTestDriveBodyType === bodyType.bodyType) {
                                    this.setState({
                                      currentTestDriveBodyType: null
                                    })
                                  } else {
                                    this.setState({
                                      currentTestDriveBodyType: bodyType.bodyType
                                    });
                                    // Cookie保存
                                    this.setCookie('mj_ddbt', this.props.shop.dealerId + ',' + this.props.shop.shopId + ',' + bodyType.bodyType);
                                    //
                                    setTimeout(()=> {
                                      BodyControl.scrollToNode(this.refs[bodyType.bodyType]);
                                    }, 100);
                                  }
                                }
                               }>
                                <img className="DealerDetailContent__text-drive__body-type__image" src={getBodyTypeImageSrc(bodyType.modelName, bodyType.carId, bodyType.carTypeCode)} />
                                <p className="DealerDetailContent__text-drive__body-type__paragraph">{bodyType.bodyType}</p>
                              </a>
                            </li>
                          )
                        } else {
                          return null;
                        }
                      })}
                    </ul>
                  </div>
                  {this.bodyTypesInfo.map((bodyType, index2)=> {
                    if (start <= index2 && index2 < start + this.testDriveBodyTypeNum) {
                      const variantsInfo = getVariantsInfo(bodyType.modelName, bodyType.carId);
                      //const variantsInfo = getVariantsInfo(bodyType.modelName, bodyType.carId, bodyType.carTypeCode);
                      return (
                        <Variant
                          variantsInfo={this.getArray(variantsInfo)}
                          isOpened={(this.state.currentTestDriveBodyType === bodyType.bodyType) ? true : false}
                          description={this.getText(this.props.testDriveCarCommonDescription)}
                          mbDescription={this.getResponsiveText(this.props.testDriveCarCommonDescription, this.props.mbTestDriveCarCommonDescription)}
                          hasTestDrive={this.props.shop.cta.hasTestDrive}
                          dealerId={this.props.shop.dealerId}
                          shopId={this.props.shop.shopId}
                          phoneNumber={this.getText(this.props.shop.contact.phoneNumber)}
                          key={index2}
                        />
                      )
                    } else {
                      return null;
                    }
                  })}
                </div>
              )
            })}
          </div>
        )
      };

      return (
        <div className="DealerDetailContent__text-drive">
          <div className="DealerDetailContent__text-drive__container">
            <div className="DealerDetailContent__text-drive__heading Wysiwyg">
              <div className="DealerDetailContent__text-drive__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.testDriveText)}}/>
              <div className="DealerDetailContent__text-drive__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.testDriveText, this.props.mbTestDriveText)}}/>
            </div>
          </div>
          {renderBodyTypes()}
        </div>
      )
    };

    // ADDRESS表示
    const renderAddress = ()=> {

      // 住所表示
      const renderAddressInfo = ()=> {
        if (this.props.shop.address) {
          // 郵便番号
          let zip = this.getText(this.props.shop.address.zip);
          if (zip !== null) zip = '〒' + zip;
          // 都道府県
          let prefecture = this.getText(this.props.shop.address.prefecture);
          if (prefecture) prefecture = ' ' + prefecture;
          // 住所1
          const address1 = this.getText(this.props.shop.address.address1);
          // 住所1
          const address2 = this.getText(this.props.shop.address.address2);
          //
          return (
            <div>
              <dl className="DealerDetailContent__address__list-dl">
                <dt>住所</dt>
                <dd>{this.getText(zip)}<br />{((prefecture) ? prefecture : '') + ((address1) ? address1 : '') + ((address2) ? address2 : '')}</dd>
              </dl>
            </div>
          )
        } else {
          return null;
        }
      };

      // TEL表示
      const renderTel = ()=> {
        if (this.props.shop.contact) {
          const phoneNumber = this.getText(this.props.shop.contact.phoneNumber);
          if (phoneNumber !== null) {
            return (
              <div>
                <dl className="DealerDetailContent__address__list-dl">
                  <dt>TEL</dt>
                  <dd>{phoneNumber}</dd>
                </dl>
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // FAX表示
      const renderFax = ()=> {
        if (this.props.shop.contact) {
          const faxNumber = this.getText(this.props.shop.contact.faxNumber);
          if (faxNumber !== null) {
            return (
              <div>
                <dl className="DealerDetailContent__address__list-dl">
                  <dt>FAX</dt>
                  <dd>{faxNumber}</dd>
                </dl>
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // 営業時間表示
      const renderOpenTime = ()=> {
        if (this.props.shop.contact) {
          let openTime = this.getText(this.props.shop.contact.openTime);
          if (openTime !== null && openTime !== ' ' && openTime !== '　') {
            openTime = openTime.replace(/<br\/>/g, '|');
            openTime = openTime.replace(/<br \/>/g, '|');
            openTime = openTime.replace(/<br>/g, '|');
            return (
              <div>
                <dl className="DealerDetailContent__address__list-dl">
                  <dt>営業時間</dt>
                  <dd className="Wysiwyg" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(openTime)}}/>
                </dl>
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // 定休日表示
      const renderCloseTime = ()=> {
        if (this.props.shop.contact) {
          let closeTime = this.getText(this.props.shop.contact.closeTime);
          if (closeTime !== null && closeTime !== ' ' && closeTime !== '　') {
            closeTime = closeTime.replace(/<br\/>/g, '|');
            closeTime = closeTime.replace(/<br \/>/g, '|');
            closeTime = closeTime.replace(/<br>/g, '|');
            return (
              <div>
                <dl className="DealerDetailContent__address__list-dl">
                  <dt>定休日</dt>
                  <dd className="Wysiwyg" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(closeTime)}}/>
                </dl>
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // Webサイトへのリンク表示
      const renderWebSiteLink = ()=> {
        if (this.props.shop.contact) {
          const websiteUrl = this.getText(this.props.shop.contact.websiteUrl);
          if (websiteUrl !== null) {
            return (
              <div className="DealerDetailContent__address__box2">
                <Cta
                  {...{
                    ctaType: 'Free',
                    href: websiteUrl,
                    text: '販売会社ホームページ',
                    targetBlank: true,
                    iconSrc: DealerDetailContent.iconBlank,
                    color: 'Dark',
                    buttonStyle: 'Action',
                    linkType: 'Button-With-Icon',
                  }}
                />
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // QRコード表示
      const renderQrCode = ()=> {
        if (this.props.shop.contact) {
          const qrCodeUrl = this.getText(this.props.shop.contact.qrCodeUrl);
          if (qrCodeUrl !== null) {
            return (
              <div className="DealerDetailContent__address__box4">
                <a className="DealerDetailContent__address__link-open" href="javascript:void(0);" onClick={(e)=> {
                  e.preventDefault();
                  //
                  this.setState({
                    isOpenedQRModal: true
                  })
                }}>QRコードを表示</a>
                <div className={'DealerDetailContent__address__modal' + ((this.state.isOpenedQRModal) ? ' open' : '')}>
                  <a className="DealerDetailContent__address__link-close" href="javascript:void(0);" onClick={(e)=> {
                    e.preventDefault();
                    //
                    this.setState({
                      isOpenedQRModal: false
                    })
                  }}>CLOSE</a>
                  <img className="DealerDetailContent__address__image-qr" src={qrCodeUrl} />
                  {/*<img src={'http://chart.apis.google.com/chart?chs=150x150&cht=qr&chl=' + qrCodeUrl} />*/}
                </div>
              </div>
            )
          } else {
            return null;
          }
        } else {
          return null;
        }
      };

      // カレンダー表示
      const renderCalenders = ()=> {

        const renderCalender = (year, month, date)=> {

          // 日表示
          const renderDate = (index, date2)=> {
            let cls = '';
            if (date2.today === true) {
              cls = 'today';
            } else if (date2.dataExist === false) {
              cls = 'blank';
            }
            if (this.serviceType.type === 'A') {
              // 新車販売・中古車・修理3つともあり
              if (date2.sales === true && date2.service === true) {
                return (
                  <td className={cls} key={index}>{date2.day}</td>
                )
              } else if (date2.sales === true && date2.service === false) {
                return (
                  <td className={cls} key={index}>{date2.day}<span>{this.getText(this.props.calendarMark1)}</span></td>
                )
              } else if (date2.sales === false && date2.service === true) {
                return (
                  <td className={cls} key={index}>{date2.day}<span>{this.getText(this.props.calendarMark2)}</span></td>
                )
              } else {
                return (
                  <td className={cls + ' blank'} key={index}>{date2.day}</td>
                )
              }
            } else if (this.serviceType.type === 'B') {
              // 新車販売・中古車ともになし
              if (date2.service === true) {
                return (
                  <td className={cls} key={index}>{date2.day}</td>
                )
              } else {
                return (
                  <td className={cls + ' blank'} key={index}>{date2.day}</td>
                )
              }
            } else if (this.serviceType.type === 'C') {
              // 修理なし
              if (date2.sales === true) {
                return (
                  <td className={cls} key={index}>{date2.day}</td>
                )
              } else {
                return (
                  <td className={cls + ' blank'} key={index}>{date2.day}</td>
                )
              }
            } else {
              return (
                <td className={cls} key={index}>{date2.day}</td>
              )
            }
          };

          // 始めの週表示
          const renderFirstWeek = ()=> {
            const arr = ['','','','','','',''];
            return (
              <tr>
                {arr.map((item, index)=> {
                  if (date[0].week <= index) {
                    count = count + 1;
                    let date2 = date[count - 1] || null;
                    if (date2) {
                      return renderDate(index, date2);
                    } else {
                      return (
                        <td key={index}></td>
                      )
                    }
                  } else {
                    return (
                      <td key={index}></td>
                    )
                  }
                })}
              </tr>
            )
          };

          // 始め以外の週表示
          const renderWeek = ()=> {
            if (date.length <= count) return null;
            const arr = ['','','','','','',''];
            return (
              <tr>
                {arr.map((item, index)=> {
                  count = count + 1;
                  let date2 = date[count - 1];
                  if (date2) {
                    return renderDate(index, date2);
                  } else {
                    return (
                      <td key={index}></td>
                    )
                  }
                })}
              </tr>
            )
          };

          let count = 0;

          let calenderCls = '';
          if (this.serviceType.type === 'A') {
            calenderCls = ' type-a';
          } else if (this.serviceType.type === 'B') {
            calenderCls = ' type-b';
          } else if (this.serviceType.type === 'C') {
            calenderCls = ' type-c';
          }

          return (
            <dl className="DealerDetailContent__address__list-dl2">
              <dt>{year + '.' + (month + 1)}</dt>
              <dd>
                <table className={'DealerDetailContent__address__calender' + calenderCls}>
                  <tbody>
                    <tr>
                      <th>MON</th>
                      <th>TUE</th>
                      <th>WED</th>
                      <th>THU</th>
                      <th>FRI</th>
                      <th>SAT</th>
                      <th>SUN</th>
                    </tr>
                    {renderFirstWeek()}
                    {renderWeek()}
                    {renderWeek()}
                    {renderWeek()}
                    {renderWeek()}
                    {renderWeek()}
                  </tbody>
                </table>
              </dd>
            </dl>
          )
        };

        //if (this.calendersInfo && 1 <= this.calendersInfo.length) {
        if (this.getArray(this.calendersInfo)) {
          if (this.calendersInfo[0] && this.calendersInfo[1]) {
            return (
              <div className="DealerDetailContent__address__box3">
                <div className="DealerDetailContent__address__box3-left">
                  {renderCalender(this.calendersInfo[0].year, this.calendersInfo[0].month, this.calendersInfo[0].date)}
                  {renderDescription()}
                </div>
                <div className="DealerDetailContent__address__box3-right last">
                  {renderCalender(this.calendersInfo[1].year, this.calendersInfo[1].month, this.calendersInfo[1].date)}
                </div>
              </div>
            )
          } else {
            return (
              <div className="DealerDetailContent__address__box3">
                <div className="DealerDetailContent__address__box3-left last">
                  {renderCalender(this.calendersInfo[0].year, this.calendersInfo[0].month, this.calendersInfo[0].date)}
                </div>
                <div className="DealerDetailContent__address__box3-right last" />
              </div>
            )
          }
        } else {
          return null;
        }

      };

      // 注釈表示
      const renderDescription = ()=> {
        //if (this.calendersInfo && 1 <= this.calendersInfo.length) {
        if (this.getArray(this.calendersInfo)) {
          if (this.serviceType.type === 'A') {
            return (
              <p className="DealerDetailContent__address__description Wysiwyg">
                <span className="DealerDetailContent__address__description-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.calendarDescription)}} />
                <span className="DealerDetailContent__address__description-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.calendarDescription, this.props.mbCalendarDescription)}} />
              </p>
            )
          } else if (this.serviceType.type === 'B' || this.serviceType.type === 'C') {
            return (
              <p className="DealerDetailContent__address__description Wysiwyg">
                <span className="DealerDetailContent__address__description-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.defaultCalendarDescription)}} />
                <span className="DealerDetailContent__address__description-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.defaultCalendarDescription, this.props.mbDefaultCalendarDescription)}} />
              </p>
            )
          }
        } else {
          return null;
        }
      };

      // マップ表示
      const renderMap = ()=> {
        // let apiKey = null;
        // if (0 <= String(location.hostname).indexOf('localhost')) {
        //   apiKey = 'AIzaSyBb0EsDARLM_4-pNHncpHquNN7_iMZM-xo';
        // } else {
        //   apiKey = 'AIzaSyBG0b5Aho-6eOQuY2XaMP0p0OzhK_Fxzb4';
        // }
        return (
          <div className="DealerDetailContent__address__map">
            <a className="DealerDetailContent__address__link-rout" href={'https://www.google.com/maps/dir/?api=1&destination=' + this.props.shop.address.latitude + ',' + this.props.shop.address.longitude} target="_blank">ルート検索</a>
            <Map
              //apiKey={apiKey}
              center={{
                lat: Number(this.props.shop.address.latitude),
                lng: Number(this.props.shop.address.longitude),
              }}
              style={{
                height: 350,
                width: '100%'
              }}
              zoom={15}
              coordinates={[
                {
                  title: this.props.shop.dealerName + ' ' + this.props.shop.shopName,
                  position: {
                    lat: Number(this.props.shop.address.latitude),
                    lng: Number(this.props.shop.address.longitude),
                  },
                  icon: MakerIcon,
                }
              ]}
            />
          </div>
        )
      };

      // マップ表示
      // const renderMap_ = ()=> {
      //   let src = '//www.google.com/maps/embed/v1/view?key=AIzaSyBb0EsDARLM_4-pNHncpHquNN7_iMZM-xo';
      //   src = src + '&center=' + this.props.shop.address.latitude + ',' + this.props.shop.address.longitude;
      //   src = src + '&zoom=15';
      //   return (
      //     <iframe className="DealerDetailContent__address__map" src={src}></iframe>
      //   )
      // };

      return (
        <div className="DealerDetailContent__address">
          <div className="DealerDetailContent__address__box">
            <div className="DealerDetailContent__address__box-left">
              <div className="DealerDetailContent__address__heading Wysiwyg">
                <div className="DealerDetailContent__address__heading-pc" dangerouslySetInnerHTML={{__html: this.getText(this.props.addressText)}}/>
                <div className="DealerDetailContent__address__heading-mb" dangerouslySetInnerHTML={{__html: this.getResponsiveText(this.props.addressText, this.props.mbAddressText)}}/>
              </div>
              {renderAddressInfo()}
              {renderTel()}
              {renderFax()}
              {renderOpenTime()}
              {renderCloseTime()}
              {renderWebSiteLink()}
              {renderQrCode()}
            </div>
            {(() => {
              // if (this.getArray(this.props.shop.calendars)) {
              if (this.getArray(this.calendersInfo)) {
                return (
                  <div className="DealerDetailContent__address__box-right">
                    {renderCalenders()}
                    {renderDescription()}
                  </div>
                )
              } else {
                return null;
              }
            })()}
          </div>
          <div className="DealerDetailContent__address__box2" ref="map">
            {renderMap()}
          </div>
        </div>
      )
    };

    if (this.getIsActiveByDate(this.props.shop.startDate, this.props.shop.endDate) === true) {
      return (
        <Wrapper
          containerId={this.props.containerId}
          containerClass={this.props.containerClass}
          anchorPoint={this.props.anchorPoint}
          anchorName={this.props.anchorName}
        >
          <div className="DealerDetailContent">
            <div className="DealerDetailContent__container">
              <div className="DealerDetailContent__container__inner">
                {renderHeader()}
              </div>
            </div>
            <div className="DealerDetailContent__container2">
              <div className="DealerDetailContent__container2__inner">
                <div className="DealerDetailContent__container2__inner-left">
                  {renderShopIntroduction()}
                </div>
                <div className="DealerDetailContent__container2__inner-right">
                  {renderOnlineService()}
                  {renderShopService()}
                </div>
              </div>
            </div>
            {(() => {
              if (this.getArray(this.offers) || this.getArray(this.props.shop.dealerInfo.information)) {
                return (
                  <div className="DealerDetailContent__container4">
                    <div className="DealerDetailContent__container4__inner">
                      {renderInformation()}
                      {renderEventCampaign()}
                    </div>
                  </div>
                )
              } else {
                return null;
              }
            })()}
            {(() => {
              if (this.getArray(this.props.shop.cars)) {
                return (
                  <div className="DealerDetailContent__container3" ref="testdrive">
                    {renderTestDrive()}
                  </div>
                )
              } else {
                return null;
              }
            })()}
            <div className="DealerDetailContent__container">
              <div className="DealerDetailContent__container__inner">
                {renderAddress()}
              </div>
            </div>
          </div>
        </Wrapper>
      )
    } else {
      return null;
    }

  }

  handleResize = () => {
    let maxHeight = 0;
    this.informationRefs.map((ref, index)=> {
      if (this.refs[ref] && this.refs[ref].clientHeight) {
        let height = this.refs[ref].clientHeight;
        if (maxHeight < height) {
          maxHeight = height;
        }
      }
    });
    this.setState({
      informationHeight: maxHeight,
    });
  };

  getText = (val = null, defaultVal = null)=> {
    if (val && val !== '') {
      return val;
    } else {
      if (defaultVal && defaultVal !== '') {
        return defaultVal;
      } else {
        return null;
      }
    }
  };

  getArray = (arr)=> {
    if (arr && arr instanceof Array && 1 <= arr.length) {
      return arr;
    } else {
      return null;
    }
  };

  getResponsiveText = (val, mbVal)=> {
    if (mbVal && mbVal !== '') {
      return mbVal;
    } else {
      if (val && val !== '') {
        return val;
      } else {
        return null;
      }
    }
  };

  getIsActiveByDate = (start = null, end = null)=> {
    if (this.today === null) return false;
    //
    if (end === null || start === null) return true;
    //
    const todayTime = this.today.getTime();
    const startDate = new Date(start.substr(0, 4), (start.substr(4, 2) - 1), start.substr(6, 2));
    const startTime = startDate.getTime();
    const endDate = new Date(end.substr(0, 4), (end.substr(4, 2) - 1), end.substr(6, 2));
    const endTime = endDate.getTime();
    if (startTime <= todayTime && todayTime <= endTime) {
      return true;
    } else {
      return false;
    }
  };

  getDateByStr = (str)=> {
    return new Date(str.substr(0, 4), (str.substr(4, 2) - 1), str.substr(6, 2));
  };

  getCalendersInfo = (date)=> {

    // カレンダー情報取得
    const getCalenders = ()=> {
      let arr = [];
      if (this.getArray(this.props.shop.calendars)) {
        let i, max;
        for (i = 0, max = this.props.shop.calendars.length; i < max; i = i + 1) {
          const calendar = this.props.shop.calendars[i];
          const date = this.getDateByStr(calendar.date);
          let week = date.getDay() - 1;
          let sales = false;
          if (calendar.sales === true) sales = true;
          let service = false;
          if (calendar.service === true) service = true;
          if (week <= -1) week = 6;
          //
          let isToday = false;
          if ((this.today.getFullYear() + '' + this.today.getMonth() + '' + this.today.getDate()) === (date.getFullYear() + '' + date.getMonth() + '' + date.getDate())) {
            isToday = true;
          }
          //
          arr.push({
            dataExist: true,
            today: isToday,
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate(),
            week: week,
            sales: sales,
            service: service,
          })
        }
      }
      return arr;
    };

    // 月情報取得
    const getMonth = (year, month, calenders)=> {
      let date = new Array(31);
      let i, max;
      for (i = 0, max = calenders.length; i < max; i = i + 1) {
        if (calenders[i].year === year && calenders[i].month === month) {
          date[calenders[i].day - 1] = calenders[i];
        }
      }
      for (i = 0, max = date.length; i < max; i = i + 1) {
        const date2 = new Date(year, month, i + 1);
        if (date2.getMonth() === month) {
          if (!date[i]) {
            //
            let week = date2.getDay() - 1;
            if (week <= -1) week = 6;
            //
            let isToday = false;
            if ((this.today.getFullYear() + '' + this.today.getMonth() + '' + this.today.getDate()) === (year + '' + month + '' + (i + 1))) {
              isToday = true;
            }
            date[i] = {
              dataExist: false,
              today: isToday,
              year: year,
              month: month,
              day: i + 1,
              week: week,
            }
          }
        }
      }
      let date2 = [];
      for (i = 0, max = date.length; i < max; i = i + 1) {
        if (date[i]) {
          date2.push(date[i]);
        }
      }
      return {
        year: year,
        month: month,
        date: date2,
      };
    };

    let arr = [];
    const todayMonth = date.getMonth();
    const todayYear = date.getFullYear();
    let nextMonth = todayMonth + 1;
    let nextYear = todayYear;
    if (12 <= nextMonth) {
      nextMonth = 0;
      nextYear = nextYear + 1;
    }
    let calenders = getCalenders();

    // 一つ目のカレンダー
    let flg = false;
    let month = getMonth(todayYear, todayMonth, calenders);
    let i, max;
    // 月の全てのデータがなかった場合
    for (i = 0, max = month.date.length; i < max; i = i + 1) {
      if (month.date[i].dataExist === true) {
        flg = true;
        break;
      }
    }
    if (flg) {
      // 販売及び、サービスが一つでもあれば
      flg = false;
      for (i = 0, max = month.date.length; i < max; i = i + 1) {
        if (this.serviceType.type === 'A') {
          if (month.date[i].sales === true || month.date[i].service === true) {
            flg = true;
            break;
          }
        } else if (this.serviceType.type === 'B') {
          if (month.date[i].service === true) {
            flg = true;
            break;
          }
        } else if (this.serviceType.type === 'C') {
          if (month.date[i].sales === true) {
            flg = true;
            break;
          }
        }
      }
      if (flg) arr.push(month);
    }

    // 二つ目のカレンダー
    flg = false;
    month = getMonth(nextYear, nextMonth, calenders);
    for (i = 0, max = month.date.length; i < max; i = i + 1) {
      if (month.date[i].dataExist === true) {
        flg = true;
        break;
      }
    }
    if (flg) {
      // 販売及び、サービスが一つでもあれば
      flg = false;
      for (i = 0, max = month.date.length; i < max; i = i + 1) {
        if (this.serviceType.type === 'A') {
          if (month.date[i].sales === true || month.date[i].service === true) {
            flg = true;
            break;
          }
        } else if (this.serviceType.type === 'B') {
          if (month.date[i].service === true) {
            flg = true;
            break;
          }
        } else if (this.serviceType.type === 'C') {
          if (month.date[i].sales === true) {
            flg = true;
            break;
          }
        }
      }
      if (flg) arr.push(month);
    }

    // arr.push(getMonth(todayYear, todayMonth, calenders));
    // arr.push(getMonth(nextYear, nextMonth, calenders));
    return arr;
  };

  getIsShopServiceType = ()=> {
    let i, max;
    let flg = false;
    let flg2 = false;
    let flg3 = false;
    for (i = 0, max = this.props.shop.services.length; i < max; i = i + 1) {
      const service = this.props.shop.services[i];
      if (service.service === '新車' && service.isHighlighted === true) flg = true;
      if (service.service === '中古車' && service.isHighlighted === true) flg2 = true;
      if (service.service === 'サービス' && service.isHighlighted === true) flg3 = true;
    }
    if ((flg === true || flg2 === true) && flg3 === true) {
      // 新車販売・中古車・修理3つともあり
      return {
        type: 'A',
        newCar: flg,
        usedCar: flg2,
        repair: flg3,
      };
    } else if (flg === false && flg2 === false) {
      // 新車販売・中古車ともになし
      return {
        type: 'B',
        newCar: flg,
        usedCar: flg2,
        repair: flg3,
      };
    } else if (flg3 === false) {
      // 修理なし
      return {
        type: 'C',
        newCar: flg,
        usedCar: flg2,
        repair: flg3,
      };
    }
  };

  // ボディタイプ情報取得
  getBodyTypesInfo = ()=> {
    let arr = [];
    if (this.getArray(this.props.shop.cars)) {
      let i, max;
      for (i = 0, max = this.props.shop.cars.length; i < max; i = i + 1) {
        const car = this.props.shop.cars[i];
        const modelName = car.modelName;
        let j, max2;
        for (j = 0, max2 = car.bodyTypes.length; j < max2; j = j + 1) {
          const bodyType = car.bodyTypes[j];
          let carTypeCode = this.getText(bodyType.defaultCarTypeCode);
          if (!carTypeCode) bodyType.generations[0].carTypeCode;
          arr.push({
            modelName: modelName,
            carId: bodyType.carId,
            bodyType: bodyType.bodyType,
            carTypeCode: carTypeCode,
          })
        }
      }
    }
    //console.log(arr);
    return arr;
  };

  // Cookie設定
  setCookie = (key, val)=> {
    let date = new Date();
    date.setTime(date.getTime() + 14 * 24 * 60 * 60 * 1000);
    document.cookie = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + ';path=/';
    //document.cookie = key + '=' + encodeURIComponent(val) + ';expires=' + date.toGMTString() + ';sameSite=true;httpOnly=false;secure=true;';
  };

  // Cookie取得
  getCookie = (key)=> {
    let arr = document.cookie.split(';');
    let i, max;
    for (i = 0, max = arr.length; i < max; i = i + 1) {
      let pair = arr[i].split('=');
      if (key === pair[0].trim()) {
        return decodeURIComponent(pair[1]);
      }
    }
    return null;
  };

  getSavedBodyType = ()=> {
    let ddbt = this.getCookie('mj_ddbt');
    if (ddbt !== null) {
      let arr = ddbt.split(',');
      if (this.props.shop.dealerId === arr[0] && this.props.shop.shopId === arr[1]) {
        let i, max;
        for (i = 0, max = this.bodyTypesInfo.length; i < max; i = i + 1) {
          if (this.bodyTypesInfo[i].bodyType === arr[2]) {
            return arr[2];
          }
        }
      }
      return null;
    }
    return null;
  };

  // イベント&キャンペーン取得
  getOffers = ()=> {
    if (this.props.shop.offers === null) return null;
    //
    let arr = [];
    let i, max;
    for (i = 0, max = this.props.shop.offers.length; i < max; i = i + 1) {
      const offer = this.props.shop.offers[i].offer;
      if (this.getIsActiveByDate(offer.startDate, offer.endDate) === true) {
        arr.push({
          title: this.getText(offer.title),
          description: this.getText(offer.description),
          imageUrl: this.getText(offer.imageUrl),
          offerLink: this.getText(offer.offerLink),
        })
      }
    }
    return this.getArray(arr);
  };

}

export default DealerDetailContent;

class Variant extends Component {
  static propTypes = {
    variantsInfo: PropTypes.array,
    isOpened: PropTypes.bool,
    description: PropTypes.string,
    mbDescription: PropTypes.string,
    hasTestDrive: PropTypes.bool,
    dealerId: PropTypes.string,
    shopId: PropTypes.string,
    phoneNumber: PropTypes.string,
  };
  static defaultProps = {
    variantsInfo: null,
    isOpened: null,
    description: null,
    mbDescription: null,
    hasTestDrive: null,
    dealerId: null,
    shopId: null,
    phoneNumber: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.state = {
      height: 0,
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  };

  shouldComponentUpdate(nextProps, nextState) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props) && JSON.stringify(nextState) === JSON.stringify(this.state)) {
      return false;
    } else {
      return true;
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  };

  componentWillUpdate(nextProps, nextState) {
    setTimeout(()=> {
      this.handleResize();
    }, 100);
  };

  render() {

    // グレード画像取得
    const getGradeImageSrc = (modelName, carId, carTypeCode, gradeId, code = null) => {
      let str = '';
      if (0 <= String(location.hostname).indexOf('localhost')) {
        str = '/assets-dev/assets/cars/';
      } else {
        str = '/globalassets/assets/cars/';
      }

      str = str + modelName + '/';
      str = str + carId + '/';
      if (carTypeCode !== null) {
        str = str + carTypeCode + '/';
        str = str + gradeId + '/';
        if (code) {
          str = str + 'common/' + gradeId + '_' + code + '_s.png';
        } else {
          str = str + 'common/' + gradeId + '_default_s.png';
        }
        str = convertKataToRome(str);
        str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        return str;
      } else {
        str = str + 'common/default_s.png';
        str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
        return str;
      }

      /*
      str = str + modelName + '/';
      str = str + carId + '/';
      str = str + carTypeCode + '/';
      str = str + gradeId + '/';
      if (code) {
        str = str + 'common/' + gradeId + '_' + code + '_s.png';
      } else {
        str = str + 'common/' + gradeId + '_default_s.png';
      }
      str = str.replace(/ /g, '-').replace(/%20/g, '-').toLowerCase();
      return str;
      */

    };

    // メモ表示
    const renderMemo = (memo)=> {
      if (memo && memo !== '') {
        return (
          <p className="DealerDetailContent__text-drive__variant__memo">{memo}</p>
        )
      } else {
        return null;
      }
    };

    // 共通詳細表示
    const renderDescription = ()=> {
      if (this.props.description) {
        return (
          <p className="DealerDetailContent__text-drive__variant__description Wysiwyg">
            <span className="DealerDetailContent__text-drive__variant__description-pc" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getText(this.props.description))}} />
            <span className="DealerDetailContent__text-drive__variant__description-mb" dangerouslySetInnerHTML={{__html: convertPipeToBrTag(this.getResponsiveText(this.props.description, this.props.mbDescription))}} />
          </p>
        )
      } else {
        return null;
      }
    };

    // CTAボタン表示
    const renderCta = (trialCarId = null, variantInfo)=> {
      if (this.props.hasTestDrive === true) {
        return (
          <div className="DealerDetailContent__text-drive__variant__cta">
            <Cta
              {...{
                ctaType: 'Free',
                href: 'https://my.mazda.co.jp/purchase/testdrive/index.html?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId,
                // href: 'https://ssl.mazda.co.jp/purchase/testdrive/input?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId,
                text: '試乗申込',
                targetBlank: false,
                color: 'Light',
                iconSrc: DealerDetailContent.iconTestDrive,
                hoverIconSrc: DealerDetailContent.iconTestDriveHover,
                buttonStyle: 'Action',
                linkType: 'Button-With-Icon',
                handleClick: (e)=> {
                  e.preventDefault();

                  // GTMイベント
                  BodyControl.setGTMEvent({
                    trialcar: variantInfo.carId,
                    trialgrade: variantInfo.grade,
                    trialvariant: variantInfo.drive + '(' + variantInfo.transmission + ')',
                    trialcolor: variantInfo.trialCarColor,
                    event: 'DealerDetailTrialCar',
                  });

                  location.href = 'https://my.mazda.co.jp/purchase/testdrive/index.html?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId;
                  // location.href = 'https://ssl.mazda.co.jp/purchase/testdrive/input?dealer_code=' + this.props.dealerId + '&shop_code=' + this.props.shopId + '&trial_car_id=' + trialCarId;
                }
              }}
            />
          </div>
        )
      } else {
        if (this.props.phoneNumber) {
          return (
            <div className="DealerDetailContent__text-drive__variant__cta">
              <div className="DealerDetailContent__text-drive__variant__cta-pc" style={{pointerEvents: 'none', cursor: 'default'}}>
                <Cta
                  {...{
                    ctaType: 'Free',
                    href: 'javascript:void(0);',
                    // href: 'tel:' + this.getText(this.props.phoneNumber).replace(/-/g, ''),
                    text: 'TEL ' + this.props.phoneNumber,
                    targetBlank: false,
                    color: 'Light',
                    buttonStyle: 'Standard',
                    linkType: 'Button',
                  }}
                />
              </div>
              <div className="DealerDetailContent__text-drive__variant__cta-mb">
                <Cta
                  {...{
                    ctaType: 'Free',
                    href: 'tel:' + this.getText(this.props.phoneNumber).replace(/-/g, ''),
                    text: '電話で試乗予約',
                    targetBlank: false,
                    color: 'Light',
                    buttonStyle: 'Standard',
                    iconSrc: DealerDetailContent.iconTel,
                    linkType: 'Button-With-Icon',
                  }}
                />
              </div>
            </div>
          )
        } else {
          return null;
        }
      }
    };

    if (this.props.variantsInfo) {

      // 100th Anniversary Special Edition > 100周年特別記念車
      const convert100th = (text) => {
        if (text && text !== '') {
          text = text.replace('100th Anniversary Special Edition 2020 WCDOTY Model', '100周年特別記念車 2020 WCDOTY受賞記念モデル');
          text = text.replace('100th Anniversary Special Edition', '100周年特別記念車');
          text = text.replace('100th Anniv Special Edition 2020 WCOTY TOP3 Model', '100周年特別記念車 2020 WCOTY TOP3選出記念モデル');
          text = text.replace('RF 35th SV', '35周年記念車');
          text = text.replace('35th SV', '35周年記念車');
          text = text.replace('XD BD Black', 'XD BD インパネ：グロスブラック');
          text = text.replace('XD BD Light Blue', 'XD BD インパネ：グロスライトブルー');
          text = text.replace('XD BD White', 'XD BD インパネ：ピュアホワイト');
          text = text.replace('15 BD i Selection Black', '15 BD i Selection インパネ：グロスブラック');
          text = text.replace('15 BD i Selection Light Blue', '15 BD i Selection インパネ：グロスライトブルー');
          text = text.replace('15 BD i Selection White', '15 BD i Selection インパネ：ピュアホワイト');
          text = text.replace('15S Leather Touring Selection Black', '15S Leather Touring Selection（ブラックレザーパッケージ）');
          text = text.replace('15S Leather Touring Selection Burgundy', '15S Leather Touring Selection（バーガンディレザーパッケージ）');
          text = text.replace('X Touring Black', 'X Touring(ブラックレザーパッケージ)');
          text = text.replace('X Touring Burgundy', 'X Touring(バーガンディレザーパッケージ)');
          text = text.replace('15 SPORT Plus', '15 SPORT＋');
          text = text.replace('XD SPORT Plus', 'XD SPORT＋');
          text = text.replace('Monitor-', 'モニター専用車 ');
          return text;
        } else {
          return text;
        }
      };

      return (
        <div className="DealerDetailContent__text-drive__variant">
          <div className={'DealerDetailContent__text-drive__variant__container' + ((this.props.isOpened) ? ' current' : '')} style={{height: this.state.height}}>
            <ul className="DealerDetailContent__text-drive__variant__list" ref="content">
              {this.props.variantsInfo.map((variant, index)=> {
                let src = null;
                if (variant.customImage) {
                  src = customCarImage;
                } else if (variant.settingExist === true || variant.settingExist === 'yes') {
                  src = getGradeImageSrc(variant.modelName, variant.carId, variant.carTypeCode, variant.grade, variant.trialCarColorCode);
                } else {
                  src = getGradeImageSrc(variant.modelName, variant.carId, null, null, null);
                  // src = getGradeImageSrc(variant.modelName, variant.carId, variant.carTypeCode, variant.grade, null);
                }
                return (
                  <li key={index}>
                    <div className="DealerDetailContent__text-drive__variant__box">
                      <div className="DealerDetailContent__text-drive__variant__box-left">
                        <img className="DealerDetailContent__text-drive__variant__image" src={src} alt=""/>
                      </div>
                      <div className="DealerDetailContent__text-drive__variant__box-center">
                        <p className="DealerDetailContent__text-drive__variant__text-grade">{convert100th(variant.grade)}</p>
                        <p className="DealerDetailContent__text-drive__variant__text-variant">{variant.fuel}<br />{variant.drive + '(' + variant.transmission + ')'}<br />{variant.trialCarColor}</p>
                      </div>
                      <div className="DealerDetailContent__text-drive__variant__box-right">
                        <div className="DealerDetailContent__text-drive__variant__box2">
                          <div className="DealerDetailContent__text-drive__variant__box2-left">
                            <p className="DealerDetailContent__text-drive__variant__text-variant">{variant.fuel + ' / ' + variant.drive + '(' + variant.transmission + ') / ' + variant.trialCarColor}</p>
                          </div>
                          <div className="DealerDetailContent__text-drive__variant__box2-right">
                            {renderCta(variant.trialCarId, variant)}
                          </div>
                        </div>
                        <Description description={variant.description} />
                        {renderMemo(variant.memo)}
                        {renderDescription()}
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      )
    } else {
      return null;
    }
  }

  handleResize = () => {
    if (this.props.isOpened === false) {
      this.setState({height: 0});
    } else {
      this.setState({height: 'auto'});
      // this.setState({height: this.refs.content.clientHeight});
    }
  };

  getText = (val = null, defaultVal = null)=> {
    if (val && val !== '') {
      return val;
    } else {
      if (defaultVal && defaultVal !== '') {
        return defaultVal;
      } else {
        return null;
      }
    }
  };

  getResponsiveText = (val, mbVal)=> {
    if (mbVal && mbVal !== '') {
      return mbVal;
    } else {
      if (val && val !== '') {
        return val;
      } else {
        return null;
      }
    }
  };

}

class Description extends Component {
  static propTypes = {
    description: PropTypes.string,
  };
  static defaultProps = {
    description: null,
  };

  constructor(props) {
    super();
    this.props = props;
    //
    this.description = null;
    if (this.props.description && this.props.description !== '') {
      let description = this.props.description.split('|');
      if (description && description instanceof Array && 1 <= description.length) {
        this.description = description;
      }
    }
    this.state = {
      isOpened: false,
    };
  }

  render() {
    if (this.description) {
      return (
        <div className="DealerDetailContent__text-drive__variant__description">
          <a className={'DealerDetailContent__text-drive__variant__link-description-open' + ((this.state.isOpened) ? ' open' : '')} href="javascript:void(0);" onClick={(e)=> {
            e.preventDefault();
            //
            this.setState({
              isOpened: !this.state.isOpened,
            })
          }}>メーカーオプション</a>
          <ul className={'DealerDetailContent__text-drive__variant__list-description' + ((this.state.isOpened) ? ' open' : '')}>
            {this.description.map((option, index)=> {
              return (
                <li key={index}>{option}</li>
              )
            })}
          </ul>
        </div>
      )
    } else {
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/containers/dealer-detail-content/index.jsx